import React, { useEffect, useRef } from 'react';
import { useMicrophoneStore } from '../stores/microphoneStore';

interface MicrophoneManagerProps {
  isMicOn: boolean;
}

const MicrophoneManager: React.FC<MicrophoneManagerProps> = ({ isMicOn }) => {
  const { setMicrophoneStream, clearMicrophoneStream } = useMicrophoneStore();
  const streamRef = useRef<MediaStream | null>(null);

  useEffect(() => {
    let isActive = true;

    const startMicrophone = async () => {
      try {
        const s = await navigator.mediaDevices.getUserMedia({ audio: true });
        if (isActive) {
          streamRef.current = s;
          setMicrophoneStream(s);
        } else {
          s.getTracks().forEach((track) => track.stop());
        }
      } catch (error) {
        console.error('Error starting microphone:', error);
        clearMicrophoneStream();
      }
    };

    const stopMicrophone = () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
        streamRef.current = null;
      }
      clearMicrophoneStream();
    };

    if (isMicOn) {
      startMicrophone();
    } else {
      stopMicrophone();
    }

    return () => {
      isActive = false;
      // Ensure stream is stopped on component unmount
      if (streamRef.current) {
        stopMicrophone();
      }
    };
  }, [isMicOn, setMicrophoneStream, clearMicrophoneStream]);

  return null;
};

export default MicrophoneManager;
